export var TOGGLE_FILTER = '[FAVORITES VIDEOS] TOGGLE FILTER';
export var toggleFavoritesVideoFilter = function (key, filter) { return function (dispatch) {
    return dispatch({
        type: TOGGLE_FILTER,
        payload: { key: key, filter: filter },
    });
}; };



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/favoritesFilter.ts
// module id = 819
// module chunks = 81